import {environment} from '../environments/environment';

export const config  = {
  baseUrl: environment.baseUrl,
  apkServiceBaseUrl: `https://magen365.com`,
  smallScreenListItemsCount: 12,
  screenListItemsCount: 12,
  SMALL_SCREEN_BREAKPOINT : 720,
  searchDebounceTime: 300,
  creditUnitPrice: 20,
  creditDiscountUnits: 10
};
